import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { reload } from '@mindtickle/utils';

import { useFreshchatHelpers } from '~/components/Freshchat';
import { useDatadogHelpers } from '~/components/Datadog';

import { APPLICATIONS, getApplicationAccessLink } from '../../../ApplicationUrls';
import { useLogout, useUserAuth } from '../../../Auth';
import { getActiveTab } from '../helper';

const useGlobalHeaderData = () => {
  const location = useLocation();
  const { company, email, features, name, tempFeatureConfig, username, image, id } = useUserAuth();
  const logout = useLogout();
  const { clearFreshchatUser } = useFreshchatHelpers();
  const { clearUser: clearDatadogUser } = useDatadogHelpers();
  const newGlobalSearchEnabled = company?.companySettings?.newGlobalSearchEnabled;

  const logoutWithCleanup = useCallback(async () => {
    await logout();
    reload(getApplicationAccessLink(APPLICATIONS.LOGIN));
    clearFreshchatUser();
    clearDatadogUser();
  }, [clearDatadogUser, clearFreshchatUser, logout]);

  const activeTab = getActiveTab(location.pathname);

  const pingEnabled = !tempFeatureConfig?.disablePing;

  return {
    activeTab,
    pingEnabled,
    logoutWithCleanup,
    company,
    user: { email, name, username, features, image, id },
    newGlobalSearchEnabled,
  };
};

export default useGlobalHeaderData;
